import { useParams } from "react-router-dom"
import { Tabs } from "../../components/Tabs"
import { TaskList } from "./TaskList"
import { useDocument } from "../../hooks/useDocument"
import  { TaskForm }  from './TaskForm'


export const Project = () => {

  const { id } = useParams()
  const { error, document } = useDocument('projects', id)


 

  if(error) {
    return <p>{ error }</p>
  }
  if(!document) {
    return <p>Loading...</p>
  }

  return (
    <>
    <div className="flex-1 p-4">
      <h2 className="text-2xl font-bold " >{ document.name }</h2>
      <Tabs project={document} />  
      
    </div>
    </>
    
  )
}